<template>
    <div id="SystemLogs">
        <div class="data_head">
            <div class="search_input">
                <el-input v-model.trim="select_word" placeholder="输入日志内容（并按Enter键）"
                 suffix-icon="iconfont icon-search" @keyup.enter.native="search()"></el-input>
            </div>
          <el-button class="searchB"  type="primary" @click="search()">查询</el-button>
        </div>
        <div class="table tableContent">
            <el-table :data="list" style="width: 100%" stripe :header-cell-style="{background:'#335ABB',color:'#FFF'}">
                <el-table-column prop="opDate" label="时间"></el-table-column>
                <el-table-column prop="opContent" label="日志内容"></el-table-column>
                <el-table-column prop="opIp" label="IP地址"></el-table-column>
                <el-table-column prop="opMethod" label="操作方法" width="600"></el-table-column>
            </el-table>
          <div class="pagination">
            <el-pagination
              @current-change="handleCurrentChange" :current-page="page"
              :page-size="pageSize" layout="total,prev, pager, next, jumper"
              :total="totalNum" class="pagination" background >
            </el-pagination>
          </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: 'SystemLogs',
        data() {
            return {
                select_word:'',
                data:[],
                list:[], // 用于存放数据
                total: null,
                totalNum:null,
                page: 1, // 初始页
                pageSize:10, // 每页显示的数据条数
            };
        },
        mounted: function () {
            this.getData();
        },
        methods:{
            getData(){
                this.token = window.localStorage.getItem('token');
                this.$axios.get(`/api/monitor/system/logs?page=`+this.page).then(res => {
                    if(res.status == 200){
                        this.total = res.data.datas.values.total;
                        this.data = res.data.datas.values.list;
                        this.getList();
                    }
                    return
                });
            },
            search(){
                this.page = 1;
                // this.getList();
                this.getData()
            },
            getList(){
                //  es6过滤得到满足搜索条件的展示数据list
                let list = this.data.filter((item) =>
                    item.opContent.includes(this.select_word)
                );
                 //过滤分页
                this.list = list.filter((item, index) =>
                    index < this.page * this.pageSize && index >= this.pageSize * (this.page - 1)
                );
                // console.log(this.list,111)
                // console.log(list.length)
                //分页的总数据
                this.totalNum = this.total
            },
            handleCurrentChange(val) { // 页码切换
                this.$axios.get(`/api/monitor/system/logs?page=${val}`).then(res => {
                    this.total = res.data.datas.values.total;
                    this.data = res.data.datas.values.list;
                    this.getList();
                });
            },
        }
    }
</script>


<style>

    #SystemLogs .search_input .el-input__inner {
        background: #3457DE;
        border: 1px solid #3457DE;
        border-radius: 6px;
        width: 230px;
        font-size: 14px;
        color:#FFF;
    }

    #SystemLogs .el-table{
        color: #A7CCF6;
    }

    #SystemLogs .el-table__row {
        background-color: #0B3A68 !important;
    }

    #SystemLogs .el-table--striped .el-table__body tr.el-table__row--striped td{
        background-color: #021535;
    }

    #SystemLogs .el-table td{
        border: unset;
    }

    #SystemLogs .el-table th.is-leaf{
        border-bottom: none;
    }

    #SystemLogs .el-pagination__total{
        color: #FFF;
    }

</style>

<style scoped>
    @import url("../../assets/css/style.css");

    /*.data_head1{*/
    /*  height: 60px;*/
    /*  margin: 15px;*/
    /*  !*padding: 20px 10px;*!*/
    /*  display: flex;*/
    /*  flex-direction: row;*/
    /*  align-items: center;*/
    /*  background-color: #0B3A68;*/
    /*  border: 1px solid gray;*/
    /*  color: #04012c;*/
    /*}*/
    .searchB{
      height: 40px;
      margin-left: 20px;
      background-color: #E68F02;
      border: #E68F02;
      color: #FFF;
    }

    .search_input{
        float: left;
        margin-left: 20px;
    }

    .pagination{
        /*margin-top: 30px;*/
        text-align: center;
    }

</style>




// WEBPACK FOOTER //
// src/components/systemSetting/SystemLogs.vue